import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import ReceiptIcon from "@mui/icons-material/Receipt";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import AuthService from "../../AuthService";
import { CardGenerico } from "../Dashboard/components/CardQuick";
import Template from "../Generico/Template";
import TituloPrincipal from "../Generico/TituloPrincipal";

const Clientes = () => {
  const [clientes, setClientes] = useState([]);
  const [buscando, setBuscando] = useState(false);
  const [pessoaInfo, setPessoaInfo] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCountPedidos, setTotalCountPedidos] = useState(0);
  const input = useRef();

  useEffect(() => {
    getClientes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage]);

  const getClientes = (valor = null) => {
    const service = new AuthService();
    setBuscando(true);

    let url = `/pessoa/clientesComPedidos?${valor ? `q=${valor}&` : ""}first=${
      rowsPerPage * page
    }&max=${rowsPerPage}`;

    service
      .request(url)
      .then((response) => {
        const totalCount = parseInt(response.headers.get("totalCount"));
        setTotalCountPedidos(totalCount);
        return response.json();
      })
      .then((data) => {
        setClientes(data);
        setBuscando(false);
      })
      .catch((err) => {
        setBuscando(false);
        console.error(err);
      });
  };

  const keyDown = (e) => {
    if (e === "click" || e.key === "Enter") {
      const valor = input.current?.children[1]?.children[0]?.value || "";
      getClientes(valor);
    }
  };

  const handleOpenDialog = (pessoa) => {
    setPessoaInfo(pessoa);
    getPedidos(pessoa);
  };

  const handleCloseDialog = () => {
    setPessoaInfo(null);
  };

  const getPedidos = (pessoa) => {
    const service = new AuthService();
    service.get(`/pedido/listPedidosPorPessoa/${pessoa.id}`).catch((err) => {
      console.error(err);
    });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Template>
      <TituloPrincipal title="Clientes" />
      <Paper sx={{ padding: "1rem" }}>
        <Box>
          <Box p={2}>
            <Grid container spacing={2} alignItems="center">
              <Grid
                size={{
                  xs: 12,
                  sm: 4,
                }}
              >
                <TextField
                  ref={input}
                  variant="outlined"
                  fullWidth
                  style={{ minWidth: "200px" }}
                  label="Nome ou Telefone"
                  name="pesquisa"
                />
              </Grid>
              <Grid height="3.5rem" width="10rem">
                <Box display="flex" sx={{ height: "100%" }} alignItems="center">
                  <Button
                    variant="contained"
                    fullWidth
                    sx={{ height: "100%" }}
                    color="primary"
                    onClick={() => keyDown("click")}
                    disabled={buscando}
                  >
                    {buscando ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : (
                      "Buscar"
                    )}
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>

          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="left">
                    <strong>Nome</strong>
                  </TableCell>
                  <TableCell align="left">
                    <strong>Telefone</strong>
                  </TableCell>
                  <TableCell align="center">
                    <strong>Detalhes</strong>
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {buscando
                  ? Array.from({ length: rowsPerPage }).map((_, index) => (
                      <TableRow key={index}>
                        <TableCell style={{ width: "60%" }}>
                          <Skeleton variant="text" width="80%" height={28} />
                          <Skeleton variant="text" width="50%" height={20} />
                        </TableCell>
                        <TableCell style={{ width: "25%" }}>
                          <Skeleton variant="text" width="80%" height={28} />
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Skeleton variant="circular" width={48} height={48} />
                        </TableCell>
                      </TableRow>
                    ))
                  : clientes.map((cliente) => (
                      <TableRow key={cliente.id}>
                        <TableCell component="th" scope="row">
                          <Typography variant="h6" color="primary">
                            {cliente.nome}
                          </Typography>
                          <Typography
                            style={{ opacity: "0.6", fontSize: "15px" }}
                          >
                            #{cliente.id}
                          </Typography>
                        </TableCell>

                        <TableCell>
                          <Typography variant="body1" color="primary">
                            {cliente.telefone}
                          </Typography>
                        </TableCell>

                        <TableCell align="center">
                          <IconButton
                            onClick={() => handleOpenDialog(cliente)}
                            size="large"
                          >
                            <VisibilityIcon color="primary" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <Box>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            labelRowsPerPage="Linhas por página"
            count={totalCountPedidos}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleRowsPerPage}
          />
        </Box>
      </Paper>
      {pessoaInfo && (
        <Dialog
          open={!!pessoaInfo}
          onClose={handleCloseDialog}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>
            <Box p="1.5rem">
              <Typography align="center" variant="h4">
                {pessoaInfo.nome}
              </Typography>
            </Box>
          </DialogTitle>
          <DialogContent>
            <Grid
              container
              spacing={3}
              style={{ overflow: "hidden", paddingBottom: "1rem" }}
            >
              <Grid
                size={{
                  xs: 12,
                  sm: 4,
                }}
              >
                <CardGenerico
                  key="TOTAL_PEDIDOS"
                  color="success"
                  url={`/pedido/informacoes/TOTAL_PEDIDOS/${pessoaInfo.id}`}
                  icon={<ReceiptIcon />}
                  maskTypeValue="int"
                />
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  sm: 4,
                }}
              >
                <CardGenerico
                  key="VALOR_PEDIDOS"
                  color="rose"
                  url={`/pedido/informacoes/VALOR_PEDIDOS/${pessoaInfo.id}`}
                  icon={<MonetizationOnIcon />}
                  maskTypeValue="double"
                />
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  sm: 4,
                }}
              >
                <CardGenerico
                  key="DATA_ULTIMO_PEDIDO"
                  color="warning"
                  url={`/pedido/informacoes/DATA_ULTIMO_PEDIDO/${pessoaInfo.id}`}
                  icon={<CalendarTodayIcon />}
                  maskTypeValue="data"
                />
              </Grid>
            </Grid>
          </DialogContent>
        </Dialog>
      )}
    </Template>
  );
};

export default Clientes;
